import { createSlice } from "@reduxjs/toolkit";
// import { getAllThemeList } from "./ThunkActions";
import { getAllRechargedThemeList , getAllMobileViewThemeList} from "./ThunkAction";
import { iThemeState, REDUCER_NAME } from "./Types"; 

// Define initial state based on the provided structure
const initialState: iThemeState = {
  isLoading: false,
  themeList:[],
  mobileThemeList:[],
  errorMessage: null,
};
export const addThemeSlice = createSlice({
  name: REDUCER_NAME, 
  initialState,
  reducers: {
    resetAddThemeState: () => {
      return initialState; 
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllRechargedThemeList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllRechargedThemeList.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.themeList = payload.data.data; 
          state.isLoading = false;
        }
      })
      .addCase(getAllRechargedThemeList.rejected, (state, action) => {
        state.errorMessage = "Failed to fetch data";
        state.isLoading = false;
      });

       builder
      .addCase(getAllMobileViewThemeList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllMobileViewThemeList.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.mobileThemeList = payload.data.data; 
          state.isLoading = false;
        }
      })
      .addCase(getAllMobileViewThemeList.rejected, (state, action) => {
        state.errorMessage = "Failed to fetch data";
        state.isLoading = false;
      });

  },
});

export const { resetAddThemeState } = addThemeSlice.actions;
export default addThemeSlice.reducer;
